import classes from "./StaffRanking.module.css";
import { RiExpandUpDownFill } from "react-icons/ri";

import { sortArrObj } from "../util/sortArrObj";
import { useState } from "react";
export default function StaffRanking({ data }) {
  //console.log("RENDERING staffRanking");
  const [ascDesc, setAscDesc] = useState(true);

  const [tableData, setTableData] = useState(data);

  if (data == null) {
    return (
      <>
        <h3>No Data</h3>
      </>
    );
  }

  function updownButtonHandler(e) {
    //console.log("button clicked for ", e.target.id);
    setAscDesc((prev) => {
      return !prev;
    });
    //console.log(ascDesc);
    setTableData((prev) => {
      return sortArrObj(prev, e.target.id, ascDesc);
    });
  }
  return (
    <>
      <div className={classes.tableContainer}>
        <table id="myTable">
          <thead>
            <tr>
              <th>
                Name
                <div
                  id="name"
                  className={classes.iconBox}
                  onClick={(e) => {
                    updownButtonHandler(e);
                  }}
                >
                  <div className={classes.icon}>
                    <RiExpandUpDownFill />
                  </div>
                </div>
              </th>
              <th>
                Score
                <div
                  id="score"
                  className={classes.iconBox}
                  onClick={(e) => {
                    updownButtonHandler(e);
                  }}
                >
                  <div className={classes.icon}>
                    <RiExpandUpDownFill />
                  </div>
                </div>
              </th>
              <th>
                Average Score{" "}
                <div
                  id="avgScore"
                  className={classes.iconBox}
                  onClick={(e) => {
                    updownButtonHandler(e);
                  }}
                >
                  <div className={classes.icon}>
                    <RiExpandUpDownFill />
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => {
              return (
                <tr key={index}>
                  <td>{row.name}</td>
                  <td>{row.score}</td>
                  <td>
                    {row.avgScore}
                    <span
                      style={{
                        fontSize: "0.8rem",
                        color: "grey",
                      }}
                    >
                      {" "}
                      {`  ( ${row.frequency})`}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* {rank.map((item, index) => {
        return (
          <p key={index}>
            {" "}
            {item[0]} {item[1]}
          </p>
        );
      })} */}
    </>
  );
}
